export const MEDCALL_PRODUCTION_HOSTNAME = 'lacountydiversion.org';
export const MEDCALL_CHANGE_DATABASE_URL = '/menu.php?switch=true';
export const MEDCALL_PROVIDER_EMAIL_MANAGER_URL = '/app/components/provider-email-manager/views/index.php';
export const MEDCALL_FACILITY_MANAGER_URL = '/app/components/facility-manager/views/index.php';
export const MEDCALL_HEADER_LOGOUT_URL = '/app/components/auth/logout/index.php';
export const MEDCALL_SESSION_LOGOUT_URL = '/logout.php';
export const MEDCALL_ACCESS_POLICIES = [
  'tools:medcall:access:~user',
  'tools:medcall:access:~full',
  'admin:access~full',
];

export type MedcallManagerAccess = {
  hasFacilityManagerAccess: boolean;
  hasProviderEmailManagerAccess: boolean;
};

export type MedcallUserTool = {
  href: string;
  label: string;
  showChevron: boolean;
};

export const isMedcallOnline = (hostname: string) => {
  return hostname === MEDCALL_PRODUCTION_HOSTNAME;
};

export const shouldRedirectFromMedcall2 = (
  routeBase: string,
  hasMedcallRouteAccess: boolean,
) => routeBase === '/tools/medcall2' && !hasMedcallRouteAccess;

export const getMedcallUserTools = (
  access: MedcallManagerAccess,
  mobile: boolean,
) => {
  const tools: MedcallUserTool[] = [
    {
      href: MEDCALL_CHANGE_DATABASE_URL,
      label: 'Change Database',
      showChevron: mobile,
    },
  ];

  if (access.hasProviderEmailManagerAccess) {
    tools.push({
      href: MEDCALL_PROVIDER_EMAIL_MANAGER_URL,
      label: 'Provider Email Manager',
      showChevron: mobile,
    });
  }

  if (access.hasFacilityManagerAccess) {
    tools.push({
      href: MEDCALL_FACILITY_MANAGER_URL,
      label: mobile ? 'Facility Email Manager' : 'Facility Manager',
      showChevron: false,
    });
  }

  return tools;
};
